module.exports = __webpack_public_path__ + "img/19.1e349bf1.jpg";